export * from "./resources.js";
export * from "./buildings.js";
export * from "./units.js";
export * from "./research.js";
export var MovementType;
(function (MovementType) {
    MovementType["ATTACK"] = "ATTACK";
    MovementType["TRANSPORT"] = "TRANSPORT";
    MovementType["RETURN"] = "RETURN";
})(MovementType || (MovementType = {}));
export var CombatResult;
(function (CombatResult) {
    CombatResult["ATTACKER_WIN"] = "ATTACKER_WIN";
    CombatResult["DEFENDER_WIN"] = "DEFENDER_WIN";
    CombatResult["DRAW"] = "DRAW";
})(CombatResult || (CombatResult = {}));
//# sourceMappingURL=index.js.map